<template>
  <div class="signupInitWrapper">
    <transition name="fade" mode="out-in">
      <SignupInitSelectMethod
        v-if="needMethod"
        key="slector"
        v-model="signupMethod"
        class="selector"
      />
      <component
        :is="selectSignupMethodComponent"
        v-else
        key="component"
        @request-facebook-signup="initFacebookSignup"
        @cancel-facebook="cancelMethodChoice"
        @signup-success="goToSignup"
      />
    </transition>
    <div class="line"></div>
    <div class="loginPrompt" @click="goToLogin">
      <span class="plain">{{ $t("band.signup.init.text.signin") }}</span>
      <span class="colored">{{ $t("band.signup.init.button.signin") }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex"

import SignupInitClassicUser from "~/components/band/signup/init/classicUser"
import SignupInitFacebookUser from "~/components/band/signup/init/facebookUser"
import SignupInitSelectMethod from "~/components/band/signup/init/selectMethod"

export default {
  components: { SignupInitSelectMethod },
  data() {
    return {
      signupMethod: "",
      availableSignupMethods: {
        SignupInitClassicUser,
        SignupInitFacebookUser,
      },
    }
  },
  computed: {
    selectSignupMethodComponent() {
      if (this.needMethod) return null
      else return this.availableSignupMethods[`SignupInit${this.signupMethod}`]
    },
    needMethod() {
      return this.signupMethod.length === 0
    },
    ...mapGetters({
      USER_HAS_IS_UNVALID_BAND: "user/IS_UNVALID_BAND",
    }),
  },
  created() {
    if (this.USER_HAS_IS_UNVALID_BAND) this.goToSignup()
  },
  methods: {
    ...mapMutations({
      DISPLAY_LOGIN: "login/DISPLAY",
      HIDE_SELF: "band_signup/HIDE",
      SET_IS_TRANSITIONING_TO_SIGNUP:
        "misc/band/signup/SET_TRANSITIONING_STATUS",
    }),
    initFacebookSignup() {
      this.signupMethod = "FacebookUser"
    },
    cancelMethodChoice() {
      this.signupMethod = ""
    },
    goToLogin() {
      this.HIDE_SELF()
      this.DISPLAY_LOGIN()
    },
    goToSignup() {
      this.HIDE_SELF()
      this.SET_IS_TRANSITIONING_TO_SIGNUP(true)
      this.$router.push({ path: "/band/signup/" })
    },
  },
}
</script>
<style scoped>
.signupInitWrapper {
  padding-bottom: 24px;
}

.loginPrompt {
  text-align: center;
  cursor: pointer;
}

.line {
  background-color: var(--color-light-grey);
  height: 1px;
  margin: 24px 0px 16px 0px;
}

.plain {
  color: var(--color-dark-grey);
}

.colored {
  color: var(--color-main);
}

.selector {
  margin-top: 24px;
}
</style>
